'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'solar-system';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'e02f';
var svgPathData = ['M391.78027,188.11719c-10.58325,10.584-24.79565,14.51953-38.61352,13.15039,23.99463,42.67187,18.31445,97.65625-17.96289,133.92773a112.44054,112.44054,0,1,1-24.47144-176.39062C309.37683,145,313.3186,130.80664,323.89014,120.23438c2.1018-2.10352,4.7583-3.09961,7.12573-4.73047C307.55249,102.98633,281.92078,96,256,96A160,160,0,1,0,369.14893,369.13672c51.0249-51.01758,59.65869-127.627,27.3623-188.14258C394.88208,183.35742,393.882,186.01367,391.78027,188.11719ZM437.03894,74.98047A255.16746,255.16746,0,0,0,147.582,24.34961c2.18775,1.80273,4.53565,3.32812,6.58276,5.375A86.82531,86.82531,0,0,1,175.0929,64.32227,208.24935,208.24935,0,0,1,403.094,108.92188c69.57764,69.56835,79.28186,176.47851,29.48755,256.68945a54.0343,54.0343,0,0,1,37.80078,30.34375C535.35034,296.67188,524.26709,162.19922,437.03894,74.98047ZM336.9071,447.67773A208.24935,208.24935,0,0,1,108.906,403.07812c-69.57764-69.57031-79.28186-176.48046-29.48755-256.6914h.0039a54.03613,54.03613,0,0,1-37.80468-30.3418c-64.968,99.2832-53.88477,233.75586,33.34338,320.97461a255.1736,255.1736,0,0,0,289.46082,50.63086c-2.19166-1.80273-4.53565-3.32812-6.58667-5.377A86.863,86.863,0,0,1,336.9071,447.67773Z', 'M256,192a64,64,0,1,0,64.00684,64A64.00408,64.00408,0,0,0,256,192ZM52.32971,52.35352a56.00252,56.00252,0,1,0,79.20374,0A55.999,55.999,0,0,0,52.32971,52.35352Zm339.45056,67.88086a48.003,48.003,0,1,0,0,67.88281A48.00959,48.00959,0,0,0,391.78027,120.23438Zm67.89,260.21484a56.00321,56.00321,0,1,0,0,79.19726A56.01156,56.01156,0,0,0,459.67029,380.44922Z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faSolarSystem = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;